import AboutSection from './aboutSection';
import Banner from './banner';
import BannerAbout from './bannerAbout';
import BannerClientes from './bannerClientes';
import BannerContacts from './bannerContactos';
import BannerDownloads from './bannerDownloads';
import BannerServico from './bannerServico';
import CareersForm from './careersForm';
import CaseStudies from './caseStudies';
import ClientsSection from './clientsSection';
import ContactsSection from './contactsSection';
import ContentContacts from './contentContacts';
import ContentContactsMap from './contentContactsMap';
import DemonstrationRequestForm from './demonstrationRequestForm';
import GovernanceSection from './governanceSection';
import LegalInformation from './legalInformation';
import MedidataMundo from './medidataMundo';
import MedidataMundoAbout from './medidataMundoAbout';
import NewsPage from './news';
import NewsDetail from './newsDetail';
import NewsSection from './newsSection';
import NossoCaminho from './nossoCaminho';
import ProductsDetailSection from './productsDetailSection';
import ProductComparation from './productComparation';
import ProductsSection from './productsSection';
import ProductsSectionHome from './productsSectionHome';
import SubProductsDetailSection from './subProductsDetailSection';
import TextAboutSection from './textAboutSection';
import TextServicoSection from './textServicoSection';
import WhistleblowingForm from './whistleblowingForm';

export default{
  Banner,
  BannerAbout,
  BannerServico,
  BannerClientes,
  BannerDownloads,
  BannerContacts,
  AboutSection,
  GovernanceSection,
  governanceSection: GovernanceSection,
  LegalInformation,
  MedidataMundo,
  MedidataMundoAbout,
  NossoCaminho,
  CaseStudies,
  ContentContacts,
  ContentContactsMap,
  DemonstrationRequestForm,
  demonstrationRequestForm: DemonstrationRequestForm,
  CareersForm,
  careersForm: CareersForm,
  WhistleblowingForm,
  whistleblowingForm: WhistleblowingForm,
  ProductComparation,
  ProductsSectionHome,
  ProductsSection,
  NewsPage,
  NewsDetail,
  NewsSection,
  ContactsSection,
  TextAboutSection,
  TextServicoSection,
  ClientsSection,
  ProductsDetailSection,
  SubProductsDetailSection
}